<template>
    <transition name="fade" @after-enter="showModalDialog = true">
        <div v-show="visible" id="userManageModal" class="ca-modal modal" :class="{'is-visible': visible}" tabindex="-1" role="dialog" aria-labelledby="manageModalLabel" :aria-hidden="!visible">
            <transition name="modal" enter-active-class="animated slideInDown" leave-active-class="animated slideOutUp">
                <div v-show="showModalDialog" class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="manageModalLabel">Manage User</h4>
                            <button type="button" class="close" aria-hidden="true" @click="doDismiss"><i class="fa fa-times"></i></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <ul v-if="hasErrors" class="list-group">
                                    <template v-for="(errors, field) in validationErrors">
                                        <li v-for="(error, index) in errors" :key="index" class="list-group-item list-group-item-danger mb-0 py-2 px-4">
                                            <i class="fas fa-exclamation-circle mr-1"></i> {{ error }}
                                        </li>
                                    </template>
                                </ul>
                                <user-form
                                    v-model="currentUser"
                                    mode="manage"
                                    :errors="validationErrors"
                                >
                                </user-form>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default waves-effect" @click="doDismiss"><i class="fa fa-times"></i> Cancel</button>
                            <button type="button" class="btn btn-primary waves-effect" @click="saveUser"><i class="fa fa-check"></i> Save</button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
import { has } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { User } from 'ca-api-client';
import UserForm from '@/components/user/form';

export default {
    name: 'UserManageModal',
    components: {
        UserForm
    },
    data() {
        return {
            id: 'userManageModal',
            currentUser: null,
            showModalDialog: false,
            validationErrors: {},
        }
    },
    computed: {
        ...mapGetters({
            visible: 'getManageUserModalShow',
        }),
        hasErrors() {
            return Object.keys(this.validationErrors).length > 0;
        },
    },
    methods: {
        ...mapActions([
            'hideManageUserModal'
        ]),
        doDismiss() {
            this.showModalDialog = false;
            setTimeout(() => {
                this.hideManageUserModal();
                this.validationErrors = {};
            }, 400);
        },
        async saveUser() {
            try {
                const user = await User.$find(ca.user.uuid);
                await user.patch({
                    id: this.currentUser.id,
                    name: this.currentUser.name,
                    config: this.currentUser.config,
                    password: this.currentUser.password || undefined,
                    password_confirmation: this.currentUser.password_confirmation || undefined,
                });

                location.reload();

                ca.notify({
                    type: 'success',
                    message: 'User updated successfully.',
                    timeout: ca.config('toast.timeout'),
                });

            } catch(error) {
                if (error.response.status === 422) {
                    this.validationErrors = error.response.data.errors;
                }
            }
        },
        async setUser() {
            try {
                const { id, name, email, additional_emails, config} = await User.$find(ca.user.uuid);

                if (!has(config, 'locale')) {
                    config.locale = window.Locale;
                }

                this.currentUser = {
                    id,
                    name,
                    email,
                    config,
                    additional_emails,
                    password: null,
                    password_confirmation: null,
                    logo: null,
                };
            } catch (error) {
                ca.confirm({type: 'apiError'});
            }
        }
    },
    watch: {
        visible(newValue) {
            if (newValue) {
                this.setUser();
            }
        }
    }

}
</script>
